import React from 'react';
import IGridTheme from './IGridTheme';

/**
 * @author Pradeep R <pradeep.rajendran@rldatix.com>
 * @createdOn Jan/22/2025
 */
export default function useGridThemes() {

    const gridThemes: IGridTheme[] = [
        {
            name: 'None', borderColor: null,
            headerBgColor: null, headerFgColor: null,
            defaultRowBgColor: null, defaultRowFgColor: null,
            alternateRowBgColor: null, alternateRowFgColor: null
        },
        {
            name: 'Green', borderColor: "#008c021a",
            headerBgColor: "#008c02", headerFgColor: "#FFF",
            defaultRowBgColor: "#FFF", defaultRowFgColor: "#000",
            alternateRowBgColor: "#008c021a", alternateRowFgColor: "#000"
        },
        {
            name: 'Pink', borderColor: "#8c003d1a",
            headerBgColor: "#b80039", headerFgColor: "#FFF",
            defaultRowBgColor: "#FFF", defaultRowFgColor: "#000",
            alternateRowBgColor: "#8c00221a", alternateRowFgColor: "#000"
        },
        {
            name: 'Yellow', borderColor: "#fcca0024",
            headerBgColor: "#fee87c", headerFgColor: "#000",
            defaultRowBgColor: "#FFF", defaultRowFgColor: "#000",
            alternateRowBgColor: "#fff4bd47", alternateRowFgColor: "#000"
        },
        {
            name: 'Blue', borderColor: "#004ccf1c",
            headerBgColor: "#4a8afff7", headerFgColor: "#FFF",
            defaultRowBgColor: "#FFF", defaultRowFgColor: "#000",
            alternateRowBgColor: "#bdd2f24a", alternateRowFgColor: "#000"
        },
        {
            name: 'Dark', borderColor: "#000",
            headerBgColor: "#181b18", headerFgColor: "#FFF",
            defaultRowBgColor: "#100f0f", defaultRowFgColor: "#e5a4f5",
            alternateRowBgColor: "#181b18", alternateRowFgColor: "#09f404"
        }

    ];

    // ---
    return {
        gridThemes
    }
}